<template>
  <div>
    <h1>{{ $t('auth.terms.header') }}</h1>
    <div v-if="!terms" class="mb-2">
      <PlaceholderLoader :style="{ height: '100px'}" />
      <PlaceholderLoader :style="{ height: '200px'}" />
      <PlaceholderLoader :style="{ height: '120px'}" />
      <PlaceholderLoader :style="{ height: '80px'}" />
      <PlaceholderLoader :style="{ height: '120px'}" />
    </div>
    <div v-if="terms">
      <div v-html="terms?.text" /><!-- eslint-disable-line vue/no-v-html -->
      <Btn v-if="terms?.isAgreed" large block @click="handleClose"> {{ $t('common.close') }} </Btn>
      <div v-else>
        <Checkbox
          v-model="isEulaAgreed"
          :label="$t('auth.terms.agreeEula')"
        />
        <Checkbox
          v-model="isPrivacyPolicyAgreed"
          :label="$t('auth.terms.agreePrivacyPolicy')"
        />
        <Btn
          class="mb-2"
          primary
          large
          block
          :loading="loading"
          :disabled="!isEulaAgreed || !isPrivacyPolicyAgreed"
          @click="handleAccept"
        >
          {{ $t('common.accept') }}
        </Btn>

        <Btn large block @click="handleLogout">{{ $t('common.logout') }}</Btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import Btn from '@acs/components-library/src/components/common/Btn.vue';
import Checkbox from '@acs/components-library/src/components/common/Checkbox.vue';
import PlaceholderLoader from '@acs/components-library/src/components/common/PlaceholderLoader.vue';
import * as auth from '@acs/components-library/src/auth.js';
import { useTermsStore } from '@acs/components-library/src/stores/termsStore';

defineOptions({ name: 'TermsPage' });

const termsStore = useTermsStore();
const { terms, loading } = storeToRefs(termsStore);

const isEulaAgreed = ref(false);
const isPrivacyPolicyAgreed = ref(false);

async function handleAccept() {
  await termsStore.accept();
}

function handleClose() {
  termsStore.close();
}

async function handleLogout() {
  handleClose();
  await auth.logout();
}
</script>

<style lang="scss" scoped></style>
